// Wait until TP is ready
function waitForTrustpilotReady(timeoutMs = 10000) {
  return new Promise((resolve, reject) => {
    if (window.Trustpilot?.loadFromElement) return resolve();
    const start = Date.now();
    const iv = setInterval(() => {
      if (window.Trustpilot?.loadFromElement) {
        clearInterval(iv); resolve();
      } else if (Date.now() - start > timeoutMs) {
        clearInterval(iv); reject(new Error('Trustpilot bootstrap timed out'));
      }
    }, 100);
  });
}

async function reloadTrustpilotWidgets(root = document) {
  try { await waitForTrustpilotReady(); } catch (e) { console.warn(e); return; }
  root.querySelectorAll('.trustpilot-widget:not([data-tp-loaded])').forEach(el => {
    try { window.Trustpilot.loadFromElement(el); el.setAttribute('data-tp-loaded','1'); }
    catch (err) { console.error('TP load failed', err); }
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', () => reloadTrustpilotWidgets());

// After Load More appends
document.addEventListener('product-grid:appended', (e) => {
  reloadTrustpilotWidgets(e.detail?.root || document);
});

// After facets re-render (themes differ; keep both hooks)
document.addEventListener('facets:updated', () => {
  reloadTrustpilotWidgets(document.getElementById('ProductGridContainer') || document);
});
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target || e.detail?.sectionElement;
  if (section?.querySelector('.trustpilot-widget')) reloadTrustpilotWidgets(section);
});

// Safety net: watch the grid for new children
(function observeGrid() {
  const grid = document.getElementById('ProductGridContainer');
  if (!grid) return;
  let t=null;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(() => reloadTrustpilotWidgets(grid), 120);
  }).observe(grid, { childList: true });
})();
